import React from 'react';
import '../template-file-css/document-file-template.css';


export const BFCS_TransitionPlan = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='BFCS_TransitionPlan' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <span className='eleHeader'>1. Transitioning to</span>
                    <input type="checkbox" id="cbMoreIntensiveLevel_1" name="cbMoreIntensiveLevel_1" className='add-only' value="1" />
                    More intensive level of services (within the organization)
                </p>
                <p className='w-750'>
                    <span className='small'>Identify:</span>
                    <textarea id="txtIdentify_1" name="txtIdentify_1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cbMoreIntensiveLevel_2" name="cbMoreIntensiveLevel_2" className='add-only' value="1" />
                    More intensive level of services (outside the organization)
                </p>
                <p className='w-750'>
                    <span className='small'>Identify:</span>
                    <textarea id="txtIdentify_2" name="txtIdentify_2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cbLessIntensiveLevel_1" name="cbLessIntensiveLevel_1" className='add-only' value="1" />
                    Less intensive level of /services (within the organization)
                </p>
                <p className='w-750'>
                    <span className='small'>Identify:</span>
                    <textarea id="txtIdentify_3" name="txtIdentify_3" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type="checkbox" id="cbLessIntensiveLevel_2" name="cbLessIntensiveLevel_2" className='add-only' value="1" />
                    Less intensive level of services (outside the organization)
                </p>
                <p className='w-750'>
                    <span className='small'>Identify:</span>
                    <textarea id="txtIdentify_4" name="txtIdentify_4" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>2. Reason for Transition</span>
                    <textarea id="txtReasonForTransition" name="txtReasonForTransition" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>3. Progress toward recovery or well-being</span>
                    <span className='small'>(This is based on a review of functioning at admission, the participant's identified needs and goals, the level of goal achievement, and the level of functioning at discharge as compared to the level of functioning at admission)</span>
                    <textarea id="txtProgressTowardRecovery" name="txtProgressTowardRecovery" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>4. Gains achieved during program participation</span>
                    <span className='small'>(How did/has the participant's life improve during program participation)</span>
                    <textarea id="txtGainsAchieved" name="txtGainsAchieved" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>5. Strengths, Needs, Abilities, Preferences</span>
                    <span className='small'>(Review this section of the Psychosocial Assessment and compare to the participants functioning at discharge. What changes have occurred in these areas as a result of program participation?)</span>
                    <textarea id="txtStrengthsNeedsAbilities" name="txtStrengthsNeedsAbilities" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>
                        6. Recommended Support Systems and Services that will support continued recovery or well-being
                    </h3>
                </p>
                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Person/Agency</span></td>
                        <td className='w-200'><span className='eleHeader'>Location/Address</span></td>
                        <td className='w-120'><span className='eleHeader'>Phone Number</span></td>
                        <td className='w-130'><span className='eleHeader'>Contact Person</span></td>
                        <td className='w-150'><span className='eleHeader'>First (or next) Appointment<span className='small'>(time and date, if known)</span></span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtPerson_1" name="txtPerson_1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtLocation_1" name="txtLocation_1" className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type="text" id="txtPhoneNumber_1" name="txtPhoneNumber_1" className='add-only' />
                        </td>
                        <td className='w-130'>
                            <input type="text" id="txtContactPerson_1" name="txtContactPerson_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtFirstAppoinment_1" name="txtFirstAppoinment_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtPerson_2" name="txtPerson_2" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtLocation_2" name="txtLocation_2" className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type="text" id="txtPhoneNumber_2" name="txtPhoneNumber_2" className='add-only' />
                        </td>
                        <td className='w-130'>
                            <input type="text" id="txtContactPerson_2" name="txtContactPerson_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtFirstAppoinment_2" name="txtFirstAppoinment_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtPerson_3" name="txtPerson_3" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtLocation_3" name="txtLocation_3" className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type="text" id="txtPhoneNumber_3" name="txtPhoneNumber_3" className='add-only' />
                        </td>
                        <td className='w-130'>
                            <input type="text" id="txtContactPerson_3" name="txtContactPerson_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtFirstAppoinment_3" name="txtFirstAppoinment_3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>Medications at transition, if applicable
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'><span className='eleHeader'>Type</span></td>
                        <td className='w-250'><span className='eleHeader'>Strength</span></td>
                        <td className='w-150'><span className='eleHeader'>Dosage</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <input type="text" id="txtType_1" name="txtType_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtStrength_1" name="txtStrength_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDosage_1" name="txtDosage_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <input type="text" id="txtType_2" name="txtType_2" className='add-only' /> </td>
                        <td className='w-250'>
                            <input type="text" id="txtStrength_2" name="txtStrength_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDosage_2" name="txtDosage_2" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>Primary contact information:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Primary Contact Person</span>
                            <input type="text" id="txtPrimaryContactPerson" name="txtPrimaryContactPerson" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Name</span>
                            <input type="text" id="txtName" name="txtName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone</span>
                            <input type="text" id="txtPhone" name="txtPhone" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Relationship to client</span>
                            <input type="text" id="txtRelationshipToClient" name="txtRelationshipToClient" className='add-only' />
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Primary Address</span>
                            <input type="text" id="txtPrimaryAddress" name="txtPrimaryAddress" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    The signatures below indicate that this transition plan was developed with the input of the program participant and/or their legal guardian, and a copy was given to the program participant, upon completion.
                </p>
                <table>
                    <tr>
                        <td className="signature w-750">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-750">Client Signature </td>
                    </tr>
                    <tr>
                        <td className="signature w-750">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-750">Staff's Signature </td>
                    </tr>
                </table>





            </div>
        </form>

    )
}











